import { call, takeLatest, put } from 'redux-saga/effects';

import * as api from '../../api';
import {
  FETCH_REFERRAL_COUPON_REQUEST,
  fetchReferralCouponSuccess,
  fetchReferralCouponFailure
} from 'store/referralCoupon/actions';

function* handleFetchReferralCouponRequest(action) {
  try {
    const response = yield call(api.fetchReferralCoupon, action.payload.id);

    yield put(fetchReferralCouponSuccess(response));
  } catch (err) {
    yield put(fetchReferralCouponFailure(err));
  }
}

export default function* referralCouponsSaga() {
  return yield takeLatest(
    FETCH_REFERRAL_COUPON_REQUEST,
    handleFetchReferralCouponRequest
  );
}



// WEBPACK FOOTER //
// ./src/store/referralCoupon/sagas.js